import { type ForwardedRef, forwardRef } from 'react';
import { IMaskMixin } from 'react-imask';

import Input, { type IInputProps } from '../input';

export interface MaskedInputInterface extends Omit<IInputProps, 'value'> {
  mask?: string;
  replacement?: { [key: string]: RegExp };
  value?: string;
  inputRef?: ForwardedRef<HTMLInputElement>;
  definitions?: { [key: string]: RegExp };
  overwrite?: boolean;
  unmask?: boolean;
  onAccept?: (value: string) => void;
}

// Создаём компонент с маской через IMaskMixin
const MaskedInputComponent = IMaskMixin<HTMLInputElement, MaskedInputInterface>(
  ({ inputRef, ...props }) => {
    return <Input ref={inputRef} {...props} />;
  }
);

// Оборачиваем в forwardRef для поддержки forwardedRef
const MaskedInput = forwardRef<HTMLInputElement, MaskedInputInterface>(
  ({ mask = '', replacement, value, onChange, ...props }, forwardedRef) => {
    return (
      <MaskedInputComponent
        inputRef={forwardedRef}
        mask={mask}
        definitions={replacement || { _: /\d/ }}
        overwrite={true}
        unmask={false}
        value={value as string}
        onAccept={(value: string) => {
          if (onChange) {
            onChange({
              target: { value }
            } as React.ChangeEvent<HTMLInputElement>);
          }
        }}
        {...props}
      />
    );
  }
);

MaskedInput.displayName = 'MaskedInput';

export default MaskedInput;
